import { atom } from 'jotai';
export const $USBanInfo = atom({
    isPreBanDuration: false,
    isPostBanDuration: false,
    isInPreBanRegion: false,
    isForbiddenCrawling: false,
    newsroom: {
        isOnline: false,
        title: '',
        subTitle: '',
        link: '',
    },
});
$USBanInfo.debugLabel = '$USBanInfo';
